import { startOfDay } from 'date-fns';
export default function isSelected(selectedDates, date) {
  if (!selectedDates) {
    return false;
  }
  return selectedDates.some(selectedDate => {
    if (selectedDate instanceof Date && startOfDay(selectedDate).getTime() === startOfDay(date).getTime()) {
      return true;
    }
    return false;
  });
}
//# sourceMappingURL=isSelected.js.map